const vuetifyTheme = {
  primary: "#1c1c7c",
  secondary: "#f5b100",
  accent: "#141457",
};

const menu = [
  {
    path: "/sobre",
    name: "Sobre",
  },
  {
    path: "/maquinas",
    name: "Máquinas",
  },
  {
    path: "/pecas",
    name: "Peças",
  },
  {
    path: "/contato",
    name: "Contato",
  },
];

export { vuetifyTheme, menu };
